import { IDeleteChecklistEntregaUseCase } from "../../../presentation/useCases/delete/delete_checklist_entrega_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteChecklistEntregaUseCase
 */

export class DeleteChecklistEntregaUseCase implements IDeleteChecklistEntregaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idChecklistEntrega: number
  ): Promise<void> {
    return this.repository.deleteChecklistEntregaById(idChecklistEntrega);

  }
}

